import HttpService from "./htttp.service";

class AuthService {
  // authEndpoint = process.env.API_URL;

  login = async (payload) => {
    const loginEndpoint = "dash/login";
    return await HttpService.post(loginEndpoint, payload);
  };

  register = async (credentials) => {
    const registerEndpoint = "dash/register";
    return await HttpService.post(registerEndpoint, credentials);
  };

  logout = async () => {
    const logoutEndpoint = "dash/logout";
    return await HttpService.post(logoutEndpoint);
  };

  forgotPassword = async (payload) => {
    const forgotPassword = "dash/password-forgot";
    return await HttpService.post(forgotPassword, payload);
  };

  resetPassword = async (credentials) => {
    const resetPassword = "dash/password-reset";
    return await HttpService.post(resetPassword, credentials);
  };

  getProfile = async () => {
    console.log("Profile Called!!");
    const getProfile = "dash/me";
    return await HttpService.get(getProfile);
  };

  getDashUsers = async () => {
    const getDashUsers = "dash/dash_users";
    return await HttpService.get(getDashUsers);
  };

  getSingleDashUser = async (id) => {
    const getSingleDashUser = `dash/dash_users/${id}`;
    return await HttpService.get(getSingleDashUser);
  };

  updateSingleDashUser = async (id, user) => {
    const updateSingleDashUser = `dash/dash_users/${id}`;
    return await HttpService.put(updateSingleDashUser, user);
  };

  activateDeactivateDashUser = async (id, user) => {
    const activateDeactivateDashUser = `dash/dash_users/active/${id}`;
    return await HttpService.put(activateDeactivateDashUser, user);
  };

  updateProfile = async (newInfo) => {
    const updateProfile = "dash/me";
    return await HttpService.patch(updateProfile, newInfo);
  };
}

export default new AuthService();
